module.exports = __webpack_public_path__ + "img/global.f13476f5.svg";